module.exports = __webpack_public_path__ + "media/images/map/home-27ccd9e4d0ebb079307aa54889c72c3b.svg";